import { render, staticRenderFns } from "./SelectFlagColor.vue?vue&type=template&id=24e352a0&"
import script from "./SelectFlagColor.vue?vue&type=script&lang=js&"
export * from "./SelectFlagColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports